import { render, staticRenderFns } from "./Authentification.vue?vue&type=template&id=0f92ffae&scoped=true&"
import script from "./Authentification.vue?vue&type=script&lang=ts&"
export * from "./Authentification.vue?vue&type=script&lang=ts&"
import style0 from "./Authentification.vue?vue&type=style&index=0&id=0f92ffae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f92ffae",
  null
  
)

export default component.exports